import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { activeTaskForms } from "reduxSlices/categorySlice"
import { submissionPermissions } from "reduxSlices/formSubmissionSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
import { GENERAL_TASK_OPTION } from "utils/taskHelpers"
import { FormsyHiddenInput } from "shared/inputs"
import { Select } from "shared/selects"
import SubformDropdown from "shared/selects/SubformDropdown"

const subformsToOptions = (subforms) => subforms.map(({ id, title }) => (
  { label: title, value: id }
))

const subformOptions = (subforms) => (
  [
    { ...GENERAL_TASK_OPTION },
    ...subformsToOptions(subforms),
  ]
)

const TaskSubformSelectInput = ({ className = "" }) => {
  const { taskSubformId, updateTaskSubformId } = useTaskFormContext()

  const { canAssignTaskWithSubform } = useSelector(submissionPermissions)

  const subforms = useSelector(activeTaskForms, isEqual)

  if (!canAssignTaskWithSubform) return null

  return (
    <div className={className}>
      <span className="block mb-1 font-semibold required-prompt">Task Form</span>
      <Select
        backspaceDelete={false}
        className="!w-full"
        dropdownRenderer={SubformDropdown}
        onChange={updateTaskSubformId}
        options={subformOptions(subforms)}
        value={taskSubformId}
        label="select task form"
      />
      <FormsyHiddenInput
        name="task.subform_id"
        required
        showErrors
        validationErrors={{ isDefaultRequiredValue: "Selection required" }}
        value={taskSubformId}
      />
    </div>
  )
}

TaskSubformSelectInput.propTypes = {
  className: types.string,
}

export default TaskSubformSelectInput
